/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function ($) {
	"use strict";
	/*globals Tc, doT, SCS, debug */
	/*jshint smarttabs:true */

	var SdxFlyoutMenu = require('sdx/menu/MenuFlyout').default;
	var SdxModal = require('lib/generic/SDXModalDialog').default;
	var deparam = require('lib/vendor/jquery-deparam-patched').default;

	/**
	 * Page module implementation.
	 *
	 * @author Rami Attallah
	 * @namespace Tc.Module
	 * @class PexCustomerList
	 * @extends Tc.Module
	 */
	Tc.Module.PexCustomerList = Tc.Module.extend({

		// config
		lazyLoadRowNumber: 10, // number of rows to display at once on scroll
		lazyLoadRowsOffset: 40, // [px] space between bottom of the list and bottom of the window before next set of rows is displayed

		// vars with module scope
		rows: [], // contains all rows except the ones filtered out by the search function
		allRows: [], // contains all rows, even the ones filtered out by the search function
		displayedRowCount: 0, // rows loaded by the lazy loader
		searchForm: $(),
		headerColumns: $(),
		tableBody: $(),
		sortInfo: {prop: '', asc: true}, // stores latest sorting info for restoring after search
		columnSourceNames: {}, // contains names of properties in the JSON to search for (search must not process all available data)
		lazyLoaderInitialized: false,
		isAgent: false,
		lastSearchTerm: '',
		isMobile: $(),
		editRowIndex: null,
		incidentAvailableStatuses: {
			ongoingIncidents: ['Start', 'Update'],
			solvedIncidents: ['End']
		},
		incidentInitStatuses: {ongoingIncidents: true, solvedIncidents: true},
		incidentCurrentStatuses: {},
		statusFromHash: '',

		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 */
		on: function (callback) {
			var mod = this;

			// init vars with module scope
			mod.itemCounter = mod.$ctx.find('.search-results span');
			mod.searchForm = mod.$ctx.find('form.search');
			mod.formCheckboxes = mod.$ctx.find('input:checkbox');
			mod.searchField = mod.$ctx.find('#search_field_pexcustomerlist');
			mod.headerColumns = mod.$ctx.find('th[data-source-name]');
			mod.tableWrapper = mod.$ctx.find('.table__wrapper');
			mod.tableBody = mod.$ctx.find('tbody');
			mod.isAgent = mod.$ctx.data('is-agent'); // boolean string is converted to boolean by jQuery
			mod.isMobile = $('body').hasClass('is-mobile'); // boolean string is converted to boolean by jQuery
			mod.isTrainingList = mod.$ctx.data('list-type') === 'training';
			mod.listUrl = mod.$ctx.data('list-url');
			mod.dialogButtonCloseText = mod.$ctx.data('dialog-button-close');
			mod.dialogButtonSaveText = mod.$ctx.data('dialog-button-save');
			mod.exportLink = mod.$ctx.find('.partner-links a[download]');
			mod.titles = mod.$ctx.data('traininglist-titles-mapping');

			// get source names of all visible table columns
			mod.headerColumns.each(function () {
				var columnSourceNamesStr = $(this).data('source-name'),
					columnSourceNamesArr = columnSourceNamesStr ? columnSourceNamesStr.split('/') : [];
				for (var i = 0; i < columnSourceNamesArr.length; i++) {
					mod.columnSourceNames[columnSourceNamesArr[i]] = true; // don't cue it in an array but set object property to true because it's faster while reading later on
				}
			});

			// reset search value when browser does auto-prefill
			mod.searchForm.find('input:text').val('');

			mod.initEventListeners();

			// load JSON when user is not an agent otherwise he has to search first
			if (!mod.isAgent) {
				if (mod.formCheckboxes.length) {
					mod.incidentCurrentStatuses = mod.incidentInitStatuses;
				}
				mod.loadJson('', function () {
					mod.readIncidentFilter();
				});
				mod.updateCsvLinkParameters();
			} else {
				// display empty message
				mod.checkEmpty();
			}

			callback();
		},

		updateCsvLinkParameters: function () {
			var $link = this.$ctx.find('.partner-links a').eq(0);
			var searchParams = $link.prop('search');
			searchParams = (searchParams ? searchParams + '&' : '?') + $.param(this.incidentCurrentStatuses);
			$link.prop('search', searchParams);
		},

		setupFadeoutEffect: function () {
			var mod = this;

			var el = mod.tableWrapper[0],
				threshold = 5,
				offset = el.scrollWidth - el.offsetWidth;

			if (el.scrollLeft > threshold && offset > threshold) {
				mod.tableWrapper.addClass('left-scroll');
			} else {
				mod.tableWrapper.removeClass('left-scroll');
			}

			if ((offset - el.scrollLeft) > threshold && offset > threshold) {
				mod.tableWrapper.addClass('right-scroll');
			} else {
				mod.tableWrapper.removeClass('right-scroll');
			}
		},

		initEventListeners: function () {
			var mod = this;

			// init sorting
			mod.headerColumns.on('click', function () {
				var $this = $(this),
					asc = $this.hasClass('sort-up');

				$this.toggleClass('sort-up', !asc);
				$this.toggleClass('sort-down', asc);
				$this.siblings().removeClass('sort-up');
				$this.siblings().removeClass('sort-down');
				mod.sort(($this.data('sort-name') ? $this.data('sort-name') : $this.data('source-name')), asc);
			});

			// init search
			mod.searchForm.on('submit', function (e) {
				e.preventDefault();
				e.stopImmediatePropagation();
				mod.search($(this).find('input:text').val());
			});

			mod.tableWrapper.on('scroll', function () {
				mod.setupFadeoutEffect();
			});

			// start search if hash value is set
			if (mod.isAgent) {
				mod.readIncidentFilter();
			}

			mod.formCheckboxes.on('change', function (e) {
				mod.formCheckboxes.each(function () {
					mod.incidentCurrentStatuses[$(this).attr('name')] = this.checked;
				});

				var searchTerm = mod.searchField.val() || '';
				mod.search(searchTerm);
				mod.updateCsvLinkParameters();
			});

			mod.exportLink.on('click', function () {
				if (mod.isTrainingList) {
					var pageTitle = $('meta[name="twitter:title"]').attr('content') || window.title;

					var keys = Object.keys(mod.titles);
					var index = keys.indexOf('title');
					// Move title to front if exists
					if(index > 0) {
						keys.splice(0, 0, keys[index]);
						keys.splice(index+1, 1);
					}
					var headers = keys.map(function(key) {return String(mod.titles[key]);})

					var rows = mod.rows
						.map(function(row) {
							return keys.map(function(title) {
								return String(row[title]);
							});
						});
					var actualDate = new Date();
					var blob = require('lib/pex/export').getXlsxBlob(
						headers,
						rows,
						pageTitle,
						{
							Company: 'Swisscom',
							Title: pageTitle,
							CreatedDate: actualDate
						}
					);
					var fileTitle = pageTitle + '-' + moment().format('YYYYMMDD_HHmmss');
					mod.exportLink.prop('download', fileTitle.replace(/\s+/, '-') + '.xlsx');
					mod.exportLink.prop('href', URL.createObjectURL(blob));
				}
			});

			// listeners for desktop only
			if (!mod.isMobile) {
				// show/hide action-dropdown
				mod.$ctx.on('mouseenter', '.people-icon', function () {
					var elem = $(this);
					if (!elem.data('qtip')) {
						elem.qtip({
							content: mod.$ctx.data('tip-text'),
							style: {
								classes: 'scs-callout',
								width: "140"
							}
						}).data('qtip').show();
					}
				});

				mod.$ctx.on('click', '.show-details', function () {
					mod.openDetailsDialog({title: event.target.textContent, buttonClose: mod.dialogButtonCloseText});
				});

				mod.$ctx.on('click', '.edit-record', function () {
					mod.openEditDialog({title: event.target.textContent, buttonClose: mod.dialogButtonCloseText, buttonSave: mod.dialogButtonSaveText});
				});

				mod.$ctx.on('click', '.add-record', function () {
					mod.editRowIndex = null;
					mod.openEditDialog({title: event.target.textContent, buttonClose: mod.dialogButtonCloseText, buttonSave: mod.dialogButtonSaveText});
				});

				mod.tableBody.on('mouseenter', 'tr', function (event) {
					var $menuButton = $(event.currentTarget).find('[data-action="dropdown-menu"]');
					mod.editRowIndex = $(this).index();

					mod.flyoutMenuInstance = $menuButton.length ? new SdxFlyoutMenu($menuButton[0]) : undefined;

					if (mod.flyoutMenuInstance) {
						mod.setMenuOpeningDirection();
						mod.flyoutMenuInstance._dynamicPlacement = false;
					}
				});

				mod.tableBody.on('mouseleave', 'tr', function () {
					if (mod.flyoutMenuInstance) {
						mod.flyoutMenuInstance.close();
					}
				});

				mod.tableBody.on('click', '.action-button', function () {
					var action = $(this).data('action'),
						$row = $(this).closest("tr");

					if (action === 'dropdown-menu' && mod.flyoutMenuInstance) {
						mod.flyoutMenuInstance.open();
					}

					if (action === 'delete') {
						mod.openConfirmationFlyout($row);
					}
				});
			}

			// listeners for mobile only
			else {
				// edit record - show form
				$(document).on('click', '.edit-record[target="newPage"]', function (event, newStage) {
					mod.editRowIndex = $(this).data('row-index');

					SCS.createNewMobilePage({
						content: mod.getFormHtml(mod.rows[mod.editRowIndex]),
						destroyOnClose: true
					});
				});

				// edit record - show form
				$(document).on('click', '.show-incident[target="newPage"]', function (event, newStage) {
					mod.editRowIndex = $(this).data('row-index');

					SCS.createNewMobilePage({
						content: mod.getDetailsHtml(mod.rows[mod.editRowIndex]),
						destroyOnClose: true
					});
				});
			}
		},

		loadJson: function (searchTerm, loadedCallback) {
			var mod = this;

			//empty table getting json might be slow
			mod.tableBody.empty();
			mod.$ctx.removeClass('is-empty');
			mod.$ctx.removeClass('max-Limit');
			mod.rows = [];
			mod.allRows = [];

			var term = searchTerm ? {term: searchTerm, '_charset_': 'UTF-8'} : {};
			var searchData = Object.assign({}, mod.incidentCurrentStatuses, term);

			$.getJSON(mod.listUrl, searchData, function (json) {
				var jsonRowArray = [],
					jsonArray = (mod.isTrainingList) ? json.trainings : json.customers;

				if (json && mod.isAgent && json.maxLimit === true) {
					mod.$ctx.removeClass('loading');
					mod.$ctx.addClass('max-Limit');
					return;
				}

				// read data from json into the "rows" array
				if (json && typeof jsonArray === "object" && jsonArray.length > 0) {
					mod.$ctx.removeClass('loading');

					jsonRowArray = $.makeArray(jsonArray); // convert json-array-object into a real array

					// process values in each row
					for (var i = 0; i < jsonRowArray.length; i++) { // not done via $.each because of memory problems with jQuery when the list contains thousands of records
						mod.processData(jsonRowArray[i], i);
					}

					mod.allRows = jsonRowArray;
					mod.rows = [].concat(mod.allRows); // create a copy of "allRows" ("mod.rows = mod.allRows" would create a reference)
					for (var key in mod.rows) {
						if (mod.rows.hasOwnProperty(key)) {
							// Trim empty values
							for (var j in mod.rows[key]) {
								if (mod.rows[key].hasOwnProperty(j)) {
									if (typeof mod.rows[key][j] === 'string') {
										mod.rows[key][j] = mod.rows[key][j].trim();
									}
								}
							}
						}
					}
				}

				// init list if data is there
				if (!mod.checkEmpty()) {
					// remove existing rows (in case of multiple searches as agent)
					mod.displayedRowCount = 0;
					mod.tableBody.empty();

					// render rows
					mod.appendRows(true);
					mod.setupFadeoutEffect();

					// restore sort if searches as agent
					if (searchTerm && mod.sortInfo.prop.length) {
						mod.sort(mod.sortInfo.prop, mod.sortInfo.asc);
					}

					if (!mod.lazyLoaderInitialized) {
						mod.lazyLoaderInitialized = true;

						// init lazy loading of rows
						$(window).on('scroll resize orientationchange', function () {
							mod.appendRows();
						});
					}
				}

				if (typeof loadedCallback === "function") {
					loadedCallback.apply(mod);
				}

			}).fail(function () {
				mod.$ctx.addClass('error-json');
			});
		},

		appendRows: function (showAnyWay) {
			var mod = this,
				win = $(window),
				bottomScrollOffset = win.height() - (mod.tableBody.height() + mod.tableBody.offset().top - win.scrollTop());

			if (mod.displayedRowCount < mod.rows.length && (showAnyWay || bottomScrollOffset > mod.lazyLoadRowsOffset)) {
				mod.tableBody.append(mod.getRowHtml(mod.rows.slice(mod.displayedRowCount, (mod.displayedRowCount += mod.lazyLoadRowNumber))));
				mod.appendRows(); // fill the viewport with rows
			}
		},

		setMenuOpeningDirection: function () {
			var mod = this;

			var $menu = $(mod.flyoutMenuInstance._flyoutElement),
				$list = $menu.find('ul');

			$list.find('a, button').removeClass('flyout__indicator');

			var bottomOffset = window.innerHeight - Math.round(mod.flyoutMenuInstance.element.getBoundingClientRect().bottom);

			if ($menu.height() > bottomOffset) {
				$list.find('li').last().find('a, button').addClass('flyout__indicator');
				$menu.addClass('flyout--top');
				$menu.closest('.dropdown').addClass('top');
			} else {
				$list.find('li').first().find('a, button').addClass('flyout__indicator');
				$menu.removeClass('flyout--top');
				$menu.closest('.dropdown').removeClass('top');
			}
		},

		getRowHtml: function (data) {
			var mod = this,
				template = mod.$ctx.find('script.tmpl-pexcustomerlistview').html(),
				templateParsed = template.replace(/\{lang}/g, $('html').attr('lang')).replace(/\{scn}/g, '{{! item.scsCustomerId}}'),
				tmplItem = doT.template(templateParsed);

			return $(tmplItem(data));
		},

		getEditFormHtml: function (data) {
			var mod = this,
				tmplItemForm = doT.template(mod.$ctx.find('script.tmpl-pexcustomerlistview-form').html());

			return tmplItemForm(data);
		},
		getDetailsHtml: function (data) {
			var mod = this,
				tmplItemForm = doT.template(mod.$ctx.find('script.tmpl-pexcustomerlistview-details').html());

			return tmplItemForm(data);
		},

		sort: function (prop, asc) {
			var mod = this;

			mod.sortInfo = {prop: prop, asc: asc};

			mod.rows.sort(function (a, b) {
				var valA = a[prop],
					valB = b[prop];

				// make dates sortable
				/* disabled because the source-data does now contain timestamps instead of date strings
				var dateA, dateB;
				if (typeof valA == "string" && valA.match(/^[0-9]{1,2}\.[0-9]{1,2}\.[0-9]{2,4}$/)) {
					dateA = valA.split('.');
					valA = (new Date(dateA[2], dateA[1] - 1, dateA[0])).getTime();
					dateB = valB.split('.');
					valB = (new Date(dateB[2], dateB[1] - 1, dateB[0])).getTime();
				}
				*/

				if (valA === null || valA === '' || valA === undefined) {
					return (asc ? 1 : -1) * (valA === valB ? 0 : -1);
				} else if (valB === null || valB === '' || valB === undefined) {
					return (asc ? 1 : -1) * (valA === valB ? 0 : 1);
				}

				if (typeof valA === 'string' && typeof valB === 'string') {
					if (Number(valA) === valA && Number(valB) === valB) {
						valA = Number(valA);
						valB = Number(valB);
					} else {
						valA = valA.toLowerCase();
						valB = valB.toLowerCase();

						// do utf8 umlaut compatible string comparison if supported by the browser
						if (typeof valA.localeCompare === 'function') {
							return (asc ? 1 : -1) * valA.localeCompare(valB);
						}
					}
				}

				// do the sorting (JS is able to compare numbers AND string with the "<", ">" operators
				return (asc ? 1 : -1) * (valA > valB ? 1 : (valA < valB ? -1 : 0));
			});

			mod.tableBody.html(mod.getRowHtml(mod.rows.slice(0, mod.displayedRowCount)));
		},

		search: function (searchString) {
			var mod = this,
				renderLater = false,
				allSearchTerms = [];

			searchString = $.trim(searchString.toLowerCase());

			mod.rows = [].concat(mod.allRows); // create a copy of "allRows" ("mod.rows = mod.allRows" would create a reference)
			mod.lastSearchTerm = searchString;

			// filter rows
			if (!mod.isAgent) {
				allSearchTerms = searchString.replace(/-\s+/g, '-').replace(/-+/g, '-').split(/\s+/g);
				allSearchTerms.sort().reverse(); // process positive terms first, then negative ones (starting with "-")
				for (var i = 0; i < allSearchTerms.length; i++) {
					mod._searchHelper(allSearchTerms[i]);
				}
			} else {
				// load filtered rows from backend
				renderLater = true;
				mod.$ctx.addClass('loading is-agent');
				mod.loadJson(searchString);
			}

			// display filtered rows
			if (!renderLater) {
				if (mod.checkEmpty()) {
					mod.tableBody.empty();
				} else {
					if (mod.sortInfo.prop.length) {
						// restore sort (rendering happens in sort function)
						mod.sort(mod.sortInfo.prop, mod.sortInfo.asc);
					} else {
						// render list
						mod.tableBody.html(mod.getRowHtml(mod.rows.slice(0, mod.displayedRowCount)));
					}
				}
			}
		},

		_searchHelper: function (searchTerm) {
			var mod = this,
				filteredRows = [],
				isIgnoringTerm = (searchTerm.substr(0, 1) === '-'),
				termFound = false,
				addRow = false,
				ignoreRow = false,
				statusExists = false;

			// remove the "-" at the beginning of the term
			if (isIgnoringTerm) {
				searchTerm = searchTerm.substr(1);
			}

			// find rows that math the given search string
			for (var i = 0; i < mod.rows.length; i++) { // not done via $.each because of memory problems with jQuery when the list contains thousands of records
				addRow = isIgnoringTerm; // always add when isIgnoringTerm
				ignoreRow = false;

				if (Object.keys(mod.incidentCurrentStatuses).length) {
					for (var currentStatus in mod.incidentCurrentStatuses) {
						var activeStatus = mod.incidentCurrentStatuses[currentStatus] ? currentStatus : '';

						if (mod.incidentAvailableStatuses[activeStatus]) {
							statusExists = mod.incidentAvailableStatuses[activeStatus].some(function (availableStatus) {
								if (mod.statusFromHash) {
									return ((mod.rows[i]['sitStatus'] === availableStatus) && (mod.rows[i]['sitStatus'] === mod.statusFromHash));
								} else {
									return mod.rows[i]['sitStatus'] === availableStatus;
								}
							});

							if (statusExists) {
								break;
							}
						}
					}

					if (!statusExists) {
						continue;
					}
				}

				for (var key in mod.rows[i]) {
					if (mod.columnSourceNames[key] && mod.rows[i][key]) {
						termFound = mod.rows[i][key] && mod.rows[i][key].toString().toLowerCase().indexOf(searchTerm) >= 0; // if you want only results that start with the given value use "=== 0" instead of ">= 0"
						if (!isIgnoringTerm && termFound) {
							addRow = true;
							break;
						} else if (isIgnoringTerm && termFound) {
							ignoreRow = true;
							break;
						}
					}
				}

				if (addRow && !ignoreRow) {
					filteredRows.push(mod.rows[i]);
				}
			}

			mod.rows = filteredRows;
		},

		checkEmpty: function () {
			var mod = this,
				isEmpty = !mod.rows.length,
				isSearchString = (location.search && location.search.length
					&& location.search.indexOf('sit=' + this.searchForm.find('input:text').val()) > -1);

			// mark/unmark list as empty
			mod.$ctx.toggleClass('is-empty', isEmpty);
			mod.$ctx.toggleClass('is-search-string', isSearchString);
			mod.$ctx.removeClass('loading');
			// show number of results
			mod.itemCounter.html(mod.rows.length);

			return isEmpty;
		},

		openDetailsDialog: function (config) {
			var mod = this,
				content = (mod.editRowIndex !== null) ? mod.rows[mod.editRowIndex] : {},
				$dialog = $(mod.getDetailsHtml(content));

			SdxModal.show({
				buttons: [
					{
						primary: false,
						title: config.buttonClose,
						type: 'close'
					}
				],
				class: 'pex-customer-list-detail',
				title: content.title ? content.title.concat(' - ' + config.title) : config.title,
				fillWidth: true,
				html: $dialog
			});
		},

		openEditDialog: function (config) {
			var mod = this,
				content = mod.editRowIndex !== null ? mod.rows[mod.editRowIndex] : {},
				$dialog = $(mod.getEditFormHtml(content));

			SdxModal.show({
				buttons: [
					{
						primary: true,
						title: config.buttonSave,
						click: $.proxy(mod.handleEditData, mod, $dialog)
					},
					{
						primary: false,
						title: config.buttonClose,
						type: 'close'
					}
				],
				class: 'pex-customer-list-detail',
				title: content.title ? content.title.concat(' - ' + config.title) : config.title,
				fillWidth: true,
				html: $dialog
			});
		},

		prepareFormData: function (form) {
			var mod = this,
				rawFormData = {},
				isFormValid = true;

			form.find('input:not([disabled])').each(function () {
				var $validationRules = $(this).data('clientvalidation');

				if ($validationRules) {
					var $validatorInstance = ScForm.createClientValidation($validationRules),
						isFieldValid = mod.validateFormField(this, $validatorInstance);

					rawFormData[this.name] = $(this).val();

					if (rawFormData.eventDate) {
						rawFormData.eventTimeStamp = SCS.utils.date.fromString(rawFormData.eventDate).getTime();

					}

					if (mod.editRowIndex !== null) {
						rawFormData.pexCustomerId = mod.rows[mod.editRowIndex].pexCustomerId;
					}

					if (!isFieldValid) {
						isFormValid = false;
					}
				}
			});

			return isFormValid ? rawFormData : {};
		},

		validateFormField: function (field, $validatorInstance) {
			var $field = $(field),
				$validatedField = $validatorInstance.validate($field.val()),
				$message = $field.siblings('.message');

			if ($validatedField.isValid) {
				$field.closest('.input-field').removeClass('error');
				$message.find('span').empty();
			} else {
				$field.closest('.input-field').addClass('error');

				if ($validatorInstance.hasLengthValidation) {
					var lengthRange = [$validatorInstance.minLength.toString(), $validatorInstance.maxLength.toString()];

					$validatedField.message = lengthRange.length ? $validatedField.message.replace(/\{([a-zA-Z0-9]+)\}/g, function (_, placeholderName) {
						return lengthRange[placeholderName];
					}) : '';
				}

				$message.find('span').text($validatedField.message);
			}

			return $validatedField.isValid;
		},

		openConfirmationFlyout: function ($row) {
			var mod = this;

			var $confirmationFlyout = $row.find('.confirm-flyout');

			if ($confirmationFlyout) {
				$confirmationFlyout.addClass('open');

				$confirmationFlyout.find('.confirm-button').on('click', function () {
					var $button = $(this);

					var confirmAction = $button.data('confirm');

					if (confirmAction === 'cancel') {
						$confirmationFlyout.removeClass('open');
					}

					if (confirmAction === 'delete-record') {
						mod.handleDeleteRecord();
					}
				});
			}
		},

		handleDeleteRecord: function () {
			var mod = this;

			$.post({
				url: mod.listUrl,
				data: {
					operation: 'delete',
					customer: {pexCustomerId: mod.rows[mod.editRowIndex].pexCustomerId}
				},
				dataType: 'json',
				traditional: false
			}).done(function (json) {
				for (var j = 0; j < mod.allRows.length; j++) {
					if (json.pexCustomerId === mod.allRows[j].pexCustomerId) {
						mod.allRows.splice(j, 1);
						break;
					}
				}
				mod.rows.splice(mod.editRowIndex, 1);
				// re-render list
				if (mod.isMobile) {
					$(document).find('.stageMobile .back').trigger('click');
				}

				if (mod.sortInfo.prop.length) {
					// restore sort (rendering happens in sort function)
					mod.sort(mod.sortInfo.prop, mod.sortInfo.asc);
				} else {
					// render list
					mod.tableBody.html(mod.getRowHtml(mod.rows.slice(0, mod.displayedRowCount)));
				}

				mod.itemCounter.html(mod.allRows.length);
			});
		},

		handleEditData: function (form) {
			var mod = this,
				formRawData = mod.prepareFormData(form),
				$formErrorMessage = SdxModal.$html.find('.headingError');

			$formErrorMessage.addClass('hidden');

			if (Object.keys(formRawData).length) {
				SdxModal.$buttons.find('.button--primary').addClass('disabled');

				$.post({
					url: mod.listUrl,
					data: {
						operation: (mod.editRowIndex !== null ? 'update' : 'create'),
						customer: formRawData,
						'_charset_': 'UTF-8'
					},
					dataType: 'json',
					traditional: false
				}).done(function (json) {
					if (mod.isMobile) {
						$(document).find('.stageMobile .back').trigger('click');
					} else {
						SdxModal.close();
					}

					if (mod.editRowIndex !== null) {
						mod.processData(json, null);
						// update
						for (var i = 0; i < mod.allRows.length; i++) {
							if (json.pexCustomerId === mod.allRows[i].pexCustomerId) {
								mod.allRows[i] = json;
								break;
							}
						}
						mod.rows[mod.editRowIndex] = json;
					} else {
						mod.processData(json, mod.getNextTableIndex());
						// create
						mod.allRows.push(json);
						mod.rows.push(json);

						mod.itemCounter.html(mod.rows.length);
					}
					// re-render list
					if (mod.sortInfo.prop.length) {
						// restore sort (rendering happens in sort function)
						mod.sort(mod.sortInfo.prop, mod.sortInfo.asc);
					} else {
						// render list
						mod.tableBody.html(mod.getRowHtml(mod.rows.slice(0, mod.displayedRowCount)));
					}
				})
					.fail(function () {
						$formErrorMessage.removeClass('hidden');
						SdxModal.$buttons.find('.button--primary').removeClass('disabled');
					});
			}
		},

		getNextTableIndex: function () {
			var mod = this,
				highestIndex = 0;

			for (var j = 0; j < mod.allRows.length; j++) {
				if (mod.allRows[j].index !== null) {
					highestIndex = Math.max(mod.allRows[j].index, highestIndex);
				}
			}

			return highestIndex + 1;
		},

		getStatusKeyByValue: function (value) {
			var mod = this;

			return Object.keys(mod.incidentAvailableStatuses).find(function (key) {
				if (mod.incidentAvailableStatuses[key].includes(value)) {
					return key;
				}
			});
		},

		loadIncidentFilter: function (params) {
			var mod = this;

			if (('incidentStatus' in params)) {
				mod.statusFromHash = params.incidentStatus;
				var statusType = mod.getStatusKeyByValue(mod.statusFromHash);

				if (statusType) {
					mod.formCheckboxes.each(function () {
						var status = ($(this).attr('name') === statusType);
						$(this).prop("checked", status).trigger('change');
					})
				}

				mod.searchForm.trigger('submit');
			}

			if (('sit' in params)) {
				mod.searchForm
					.find('input:text')
					.val(params.sit);

				mod.searchForm.trigger('submit');
			}
		},

		readIncidentFilter: function () {
			if (location.search && !!location.search.length) {
				var params = deparam(location.search.substr(1));
				if (params) {
					this.loadIncidentFilter(params);
				}
			}
		},

		processData: function (row, index) {
			var rowDate;
			// process date -> not done via "moment" library because of performance when the list contains thousands of records (at 710 records the lib takes 30ms and the native way only 2ms)
			if (row.eventTimeStamp !== null) {
				rowDate = new Date(Number(row['eventTimeStamp'])); // number conversion because otherwise Firefox prints "invalid date"
				row.eventDate = (rowDate.getDate() < 10 ? '0' : '') + rowDate.getDate() + '.' + (rowDate.getMonth() < 9 ? '0' : '') + (rowDate.getMonth() + 1) + '.' + (rowDate.getFullYear());
			}
			if (row.sitStartTime !== null) {
				rowDate = new Date(Number(row['sitStartTime'])); // number conversion because otherwise Firefox prints "invalid date"
				row.sitStartDate = (rowDate.getDate() < 10 ? '0' : '') + rowDate.getDate() + '.' + (rowDate.getMonth() < 9 ? '0' : '') + (rowDate.getMonth() + 1) + '.' + (rowDate.getFullYear());
			}

			if (row.sitLastUpdate !== null) {
				rowDate = new Date(Number(row['sitLastUpdate'])); // number conversion because otherwise Firefox prints "invalid date"
				row.sitLastUpdateDate = (rowDate.getDate() < 10 ? '0' : '') + rowDate.getDate() + '.' + (rowDate.getMonth() < 9 ? '0' : '') + (rowDate.getMonth() + 1) + '.' + (rowDate.getFullYear());
			}

			// move users reference from "data" property one level up for easier search and sort
			if (row.data) {
				row.linkName = row.data.linkName;
				row.linkUrl = row.data.linkUrl;
			}

			if (row.linkUrl && row.linkUrl.substr(0, 4).toLowerCase() !== 'http') {
				row.linkUrl = 'http://' + row.linkUrl;
			}

			if (row.customerPhoneNumber) {
				row.phoneNumber = row.customerPhoneNumber.replace(/\s+/g, '');
			}

			if (index !== null && !row.hasOwnProperty('index')) {
				row['index'] = index;
			}

			// protect user from destructive html/script injection (XSS)
			for (var key in row) {
				//noinspection JSUnfilteredForInLoop
				if (typeof row[key] === 'string' && row[key].indexOf('<') >= 0) {
					//noinspection JSUnfilteredForInLoop
					row[key] = row[key].replace(/</g, '&lt;');
				}
			}
		}

	});
}(Tc.$));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.PexCustomerList.js
// module id = 160
// module chunks = 0